// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"31d6cfe0","192":"08e7c93c","795":"f6a7232b"}[chunkId] + ".chunk.css";
};